import { render } from "./BaseButton.vue?vue&type=template&id=344d4cf9&scoped=true&ts=true"
import script from "./BaseButton.vue?vue&type=script&lang=ts"
export * from "./BaseButton.vue?vue&type=script&lang=ts"

import "./BaseButton.vue?vue&type=style&index=0&id=344d4cf9&lang=scss&scoped=true"
import "./BaseButton.vue?vue&type=style&index=1&id=344d4cf9&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344d4cf9"]])

export default __exports__